export const AUTH_USER = "auth_user";
export const AUTH_ERROR = "auth_error";
// export const SET_TENANT_ROLE_ID = "SET_TENANT_ROLE_ID";
